import { createRouter, createWebHistory } from "vue-router";
import Login from "./pages/Login.vue";
import NotFound from "./pages/NotFound.vue";
import Register from "./pages/Register.vue";
import MainPage from "./pages/MainPage.vue";
import BuyTransport from "./pages/BuyTransport.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", redirect: "/login" },
    { path: "/login", component: Login },
    { path: "/register", component: Register },
    { path: "/main", component: MainPage },
    { path: "/buy-transport", component: BuyTransport },
    { path: "/:notFound(.*)", component: NotFound },
  ],
});

export default router;
